export default __webpack_public_path__ + "static/media/card_article.072816fd.jpg";